// export const APIUrl = "https://www.fantasylive.cc/agt"
// export const APIUrlNode = "https://agent.fantasylive.cc"
export const APIUrl = "https://dream-agent.guangzhoumaitian.com"
export const APIUrlNode = "https://dream-agent.guangzhoumaitian.com"
// export const APIUrl = "http://localhost:30001"
// export const APIUrlNode = "http://localhost:30001"



// WEBPACK FOOTER //
// ./src/api/config.js